import CreateModuleModal, {
  CreateModuleModalInterface,
} from 'modules/courses/courses/curriculum/components/create-module-modal'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { EmptyListIcon } from '@systemeio/ui/icons'

interface CourseCurriculumEmptyListInterface extends Omit<CreateModuleModalInterface, 'withIcon'> {}

const CourseCurriculumEmptyList = ({
  onModuleCreate,
  courseId,
  disabled,
}: CourseCurriculumEmptyListInterface) => {
  const { t } = useLocoTranslation()
  return (
    <div className="bg-background-secondary mt-5 flex w-full flex-col items-center justify-center gap-3 rounded-lg py-20">
      <EmptyListIcon />
      <div className={`flex flex-col items-center`}>
        <span className={'text-text-primary text-base'}>{t('dashboard.list.empty_title')}</span>
        <span className={'text-text-primary text-base'}>{t('dashboard.list.empty_list')}</span>
      </div>
      <CreateModuleModal
        onModuleCreate={onModuleCreate}
        courseId={courseId}
        disabled={disabled}
        withIcon={false}
      />
    </div>
  )
}

export default CourseCurriculumEmptyList
